import { createRoot, hydrateRoot } from "react-dom/client";
import App from "./App.tsx";
import { pageFor } from "./routes";
import "./index.css";

declare global {
  interface Window {
    /** Set by the inline observer the prerender places after #root (build/compose.ts). */
    __rootGuard?: { tampered: boolean; stop: () => void };
  }
}

const container = document.getElementById("root")!;
const guard = window.__rootGuard;
const pathname = window.location.pathname.replace(/\/+$/, "") || "/";

// Load the current route's chunk first, so the first client render produces the
// same markup the server did instead of a Suspense fallback.
pageFor(pathname)
  .preload()
  .catch(() => undefined)
  .finally(() => {
    guard?.stop();
    const prerendered =
      container.dataset.route === pathname && container.firstElementChild && !guard?.tampered;

    if (prerendered) {
      hydrateRoot(container, <App />, {
        // A recoverable mismatch is re-rendered on the client and the page works;
        // note it without raising a console error.
        onRecoverableError: (error) => console.warn("Hydration recovered:", error),
      });
    } else {
      // No prerendered HTML for this URL (dev server, an unknown path served the
      // SPA fallback, or the DOM was changed before hydration): render fresh.
      container.textContent = "";
      createRoot(container).render(<App />);
    }
  });
